import { useNavigate } from 'react-router'
import { Button, Grid, Typography } from '@mui/material'

import registrationCompleteImage from '../../../images/hsp-plus/registration-complete.svg'
import useIsMobile from '../../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const HSPRegistrationComplete = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const classes = useStyles

  return (
    <Grid container={true} component="section" sx={classes.screen(isMobile)}>
      <Grid container={true} sx={classes.intro(isMobile)}>
        <img src={registrationCompleteImage} alt="" aria-hidden="true" width={256} height={256} />
        <Typography component="h1" variant="h5" sx={classes.title}>
          Registration complete! Your account is good to go
        </Typography>
      </Grid>
      <Grid container={true} sx={classes.submitContainer}>
        <Button variant="contained" size="large" disableElevation onClick={() => navigate('/hsp-plus/app-download')}>
          Continue
        </Button>
      </Grid>
    </Grid>
  )
}

export default HSPRegistrationComplete
